module.exports = __webpack_public_path__ + "static/media/astronot.aa96169c.webp";